import { useSelector, useDispatch } from 'react-redux';
import FJPromptInput from './FJPromptInput';
import { setSlicePromptAction } from '../../../redux/slices/FJSliceImageToImage';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';

const FJPromptInputContainer = () => {
    useLocalStore();
    const prompt = useSelector(state => state.imageToImage.prompt);
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const dispatch = useDispatch();
    const changePrompt = value => {
        dispatch(setSlicePromptAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };
    return (
        <FJPromptInput
            prompt={prompt}
            uploadImageInfo={uploadImageInfo}
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            changePrompt={changePrompt}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
        />
    );
};
export default FJPromptInputContainer;
